export default __webpack_public_path__ + "static/media/pepper_chat.5a1e09bd.svg";